// EmailJS Configuration
// Replace these with your actual EmailJS credentials from https://www.emailjs.com/

export const emailConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'your_template_id',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key',
  adminEmail: process.env.REACT_APP_ADMIN_EMAIL || 'support@terminteiler.com'
};

// Instructions for setup:
// 1. Go to https://www.emailjs.com/ and create an account
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create an email template with these variables:
//    - {{from_name}} - User's name
//    - {{from_email}} - User's email
//    - {{phone}} - User's phone
//    - {{subject}} - Email subject
//    - {{message}} - User's message
//    - {{to_email}} - Admin email
//    - {{to_name}} - Admin name
//    - {{reply_to}} - Reply to email
// 4. Copy your Service ID, Template ID, and Public Key
// 5. Create a .env file in the root directory with:
//    REACT_APP_EMAILJS_SERVICE_ID=your_service_id
//    REACT_APP_EMAILJS_TEMPLATE_ID=your_template_id
//    REACT_APP_EMAILJS_PUBLIC_KEY=your_public_key
//    REACT_APP_ADMIN_EMAIL=admin@termin-teiler.de
